
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { updateFaultCode, getAlarmSetDetail } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiUpdataFile extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private gradeList!: objAny[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private typeList!: objAny[];
  private formInline: objAny = {
    faultCode: "",
    faultName: "",
    faultEnName: "",
    faultTipMsg: "",
    faultTipEnMsg: "",
    solution: "",
    alarmLevel: "",
    alarmType: ""
  };
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("alarmSet.add");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    faultCode: [
      {
        required: true,
        message: i18n.t("alarmSet.faultCodePl"),
        trigger: "blur"
      }
    ],
    faultName: [
      {
        required: true,
        message: i18n.t("alarmSet.faultNamePl"),
        trigger: "blur"
      }
    ],
    faultEnName: [
      {
        required: true,
        message: i18n.t("alarmSet.faultEnNamePl"),
        trigger: "blur"
      }
    ],
    faultTipMsg: [
      {
        required: true,
        message: i18n.t("alarmSet.faultTipMsgPl"),
        trigger: "blur"
      }
    ],
    faultTipEnMsg: [
      {
        required: true,
        message: i18n.t("alarmSet.faultTipEnMsgPl"),
        trigger: "blur"
      }
    ],
    solution: [
      {
        required: true,
        message: i18n.t("alarmSet.solutionPl"),
        trigger: "blur"
      }
    ]
  };
  private isAdd = false;
  private faultCode = "";
  public open(item?: objAny) {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;
    if (!item) {
      this.isAdd = true;
      this.formInline.faultCode = "";
      this.formInline.faultName = "";
      this.formInline.faultTipMsg = "";
      this.formInline.solution = "";
      this.formInline.alarmLevel = "";
      this.formInline.alarmType = "";
      this.formInline.faultEnName = "";
      this.formInline.faultTipEnMsg = "";

      this.modalTitle = i18n.t("alarmSet.add");
    } else {
      this.isAdd = false;
      this.faultCode = item.faultCode;

      this.modalTitle = i18n.t("alarmSet.updata");
      this.getAlarmSetDetail();
    }
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    const ret = await updateFaultCode(json);
    if (ret.status === this.$config.apiStatus) {
      if (this.isAdd) {
        this.$Message.success(i18n.t("addSuccess"));
      } else {
        this.$Message.success(i18n.t("updateSuccess"));
      }
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  async getAlarmSetDetail(): Promise<void> {
    this.loading = true;
    const ret = await getAlarmSetDetail({ faultCode: this.faultCode });
    if (ret.status === this.$config.apiStatus) {
      this.formInline.faultCode = ret.data[0].faultCode + "";
      this.formInline.faultName = ret.data[0].faultName + "";
      this.formInline.faultTipMsg = ret.data[0].faultTipMsg + "";
      this.formInline.solution = ret.data[0].solution + "";
      this.formInline.alarmLevel = ret.data[0].alarmLevel + "";
      this.formInline.alarmType = ret.data[0].alarmType + "";
      this.formInline.faultEnName = ret.data[0].faultEnName;
      this.formInline.faultTipEnMsg = ret.data[0].faultTipEnMsg;
    }
    this.loading = false;
  }
}
